export default __webpack_public_path__ + "static/media/CheckMark.4e46848e.svg";